import { IconBrandAndroid, IconBrandApple, IconCirclePlus, IconCopy, IconKey, IconLink, IconPencil, IconWorldWww } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getOrganizationList } from '../../api/api.global';
import { getApi, postApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import TableComponent from '../../components/DataTable/TableComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { PROFILE } from '../../statics/localStorage';
import { getOrgNameFromOrgId } from '../../utils/dataInterChange';
import { dateTimeConverter, newsDateFormat } from '../../utils/dateTimeConverter';
import AddAppModal from './Components/AddAppModal';
import CdnModal from './Components/CdnModal';
import FallbackUrlModal from './Components/FallbackUrlModal';
import UpdateAppModal from './Components/UpdateAppModal';
import { accessCheck } from '../../utils/accessCheck';
import { accessKeys } from '../../statics/accessKeys';
import RequestPlan from '../../components/Plan/RequestPlan';
import WebHookModal from './Components/WebHookModal';
import PredefinedPromotionUrlsSection from './Components/PredefinedPromotionUrlsSection';

const DeveloperSection = () => {

    const [productDetails, setProductDetails] = useState(null);
    const [appList, setAppList] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const profileData = PROFILE();

    const getProductDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getProductDetails);
        loadingHide();
        if (resp.responseCode === 200) {
            setProductDetails(resp.data);
        } else {
            setProductDetails(null);
        }
    }

    const register = async () => {
        let postData = {
            productName: document.getElementById('productName')?.value,
            productWebsiteUrl: document.getElementById('productWebsiteUrl')?.value
        }
        if (!postData.productName || !postData.productWebsiteUrl) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        loadingShow();
        let resp = await postApi(postData, urlApi.registerProduct);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getOrganizationList();
            getProductDetails();
        } else {
            toast.error(resp.message);
        }
    }

    const updateProduct = async () => {
        let postData = {
            productName: document.getElementById('productName')?.value,
            productWebsiteUrl: document.getElementById('productWebsiteUrl')?.value
        }
        if (!postData.productName || !postData.productWebsiteUrl) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        loadingShow();
        let resp = await postApi(postData, urlApi.updateProduct);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getProductDetails();
            getOrganizationList();
            setIsEdit(false);
        } else {
            toast.error(resp.message);
        }
    }

    const getAppList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.appList);
        loadingHide();
        if (resp.responseCode === 200) {
            setAppList(resp.data);
        } else {
            setAppList([]);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys.viewProductAndAppDetails)) {
            getProductDetails();
            getAppList();
        }
    }, []);

    function onCopy(copyText) {
        navigator.clipboard
            .writeText(copyText)
            .then(() => {
                toast.success("App Key copied");
            })
            .catch(() => {
                toast.error("something went wrong");
            });
    }

    const columns = [
        {
            name: "", center: "true", selector: (row) => row?.appPlatform, width: "60px", cell: (app) => (
                <div>  {app?.appPlatform == 1 ? <IconBrandAndroid /> : app?.appPlatform == 2 ? <IconBrandApple /> : <IconWorldWww />}</div>
            )
        }, {
            name: "App ID", center: "true", selector: (row) => row?.title, grow: 0.4, cell: (row) => (
                <p className="mb-0">{row?.appId}</p>
            )
        }, {
            name: "App Key", center: "true", selector: (row) => row?.link, grow: 0.8, cell: (row) => (
                <div className="flex items-center gap-2">
                    <p>{row?.appKey}</p>
                    <button onClick={() => onCopy(row?.appKey)}> <IconCopy size={18} /> </button>
                </div>
            )
        }, {
            name: "Target", center: "true", selector: (row) => row?.title, grow: 1.0, cell: (row) => (
                <div>
                    <p className='mb-1.5'>{row?.appPlatform == 1 ? "SHA256 Key" : row?.appPlatform == 2 ? "Bundle ID" : row?.appPlatform == 3 ? "Web URL" : ""}</p>
                    {row?.appPlatform == 1 && <p className="text-xs text-gray-500 font-light break-words">{row?.appSHA256 || "--"}</p>}

                    {row?.appPlatform == 2 && <p className="text-xs text-gray-500 font-light break-words">{row?.appBundleId || "--"}</p>}

                    {row?.appPlatform == 3 && <p className="text-xs text-gray-500 font-light break-words">{row?.appWebUrl || "--"}</p>}
                </div>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.status, width: "70px", cell: (app) => (
                <p className={`text-xs text-${app?.appStatus == 0 ? "red" : app?.appStatus == 1 ? "green" : "gray"}-500 font-light`}>{app?.appStatus == 0 ? "Inactive" : app?.appStatus == 1 ? "Active" : "Deleted"}</p>
            )
        }, {
            name: "Created", center: "true", selector: (row) => row?.title, grow: 0.4, cell: (row) => (
                <p className="mb-0"> {dateTimeConverter(row?.createdAt)}</p>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.link, omit: !accessCheck(accessKeys.addAndUpdateApp), width: "90px", cell: (row) => (
                <UpdateAppModal buttonComponent={<IconButton icon={<IconPencil size={18} />} text={"Edit"} />} callback={() => getAppList()} appData={row} />
            )
        }
    ];

    if (profileData?.planRequestStatus != 3) {
        return (
            <Layout>
                <RequestPlan profileData={profileData} />
            </Layout>
        )
    }

    return (
        <Layout>
            <div className='mb-3'>
                <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Developers section</p>
            </div>

            {(!productDetails?._id || isEdit) && <div className="flex justify-center px-auto md:px-40 mb-10">
                <div className='p-3 border-2 rounded-xl text-center w-full'>
                    <div className="mb-2 text-start">
                        <label htmlFor="productName" className='text-sm font-semibold mb-1'>Product Name*</label>
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' disabled={getOrgNameFromOrgId(profileData?.defaultOrganizationId
                        )?.toLowerCase() != "default"} id='productName' defaultValue={productDetails?.productName || getOrgNameFromOrgId(profileData?.defaultOrganizationId
                        )} />
                    </div>
                    <div className="mb-6 text-start">
                        <label htmlFor="productWebsiteUrl" className='text-sm font-semibold mb-1'>Website URL*</label>
                        <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='productWebsiteUrl' defaultValue={productDetails?.productWebsiteUrl} />
                    </div>

                    {accessCheck(accessKeys.registerAndUpdateProduct) && <div className='flex items-center justify-end gap-3'>
                        {isEdit && <button className='modal-cancel-btn' onClick={() => setIsEdit(false)}>Cancel</button>}
                        <button className='primary-btn' onClick={isEdit ? () => updateProduct() : () => register()}>{isEdit ? "Update Product" : "Register Product"}</button>
                    </div>}
                </div>
            </div>}

            {
                (productDetails?._id && !isEdit) && <div className='container mx-auto flex justify-center mb-10'>
                    <div className='flex flex-col space-y-8 w-full px-16 max-w-xl'>
                        <div className="h-56 w-96 p-6 rounded-xl shadow-lg">
                            <div className="h-full flex flex-col justify-between">
                                <div className="flex items-start justify-between space-x-4">
                                    <div>
                                        <div className="text-xl font-semibold tracking-tight capitalize underline mb-1">
                                            Product
                                        </div>
                                        <p className='text-xs font-medium'>ID : {productDetails?.productId}</p>
                                    </div>

                                    <div className="inline-flex flex-col items-center justify-center">
                                        <Link to={productDetails?.productWebsiteUrl} target='_blank'> <IconLink size={20} /></Link>
                                        <div
                                            className={`text-sm font-semibold ${productDetails?.productStatus == 0 ? "text-white" : productDetails?.productStatus == 1 ? "text-green-700" : "text-red-700"}`}>
                                            {productDetails?.productStatus == 0 ? "Inactive" : productDetails?.productStatus == 1 ? "Active" : "Deleted"}
                                        </div>
                                    </div>
                                </div>

                                <div className="!pb-4">
                                    <div className="text-xs font-semibold tracking-tight">
                                        {newsDateFormat(productDetails?.createdAt)}
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <p className='text-2xl font-semibold '>{productDetails?.productName}</p>
                                        <button onClick={() => setIsEdit(true)}> <IconPencil /> </button>
                                    </div>

                                    <div className='flex items-center gap-2'>
                                        {appList?.length > 0 && <CdnModal />}
                                        <WebHookModal />
                                        <FallbackUrlModal buttonComponent={<button className='text-xs border-2 border-green-300 shadow-sm !px-2 !py-0.5 text-gray-700 rounded-md font-semibold'>Fallback URLs</button>} productData={productDetails} callback={() => getProductDetails()} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="relative cursor-pointer" onClick={() => { navigator.clipboard.writeText(productDetails?.productKey); toast.success("Product Key copied.") }}>
                            <div
                                className="absolute right-10 flex items-center space-x-2 bg-white text-gray-900 border-gray-200 shadow-2xl -mt-16 w-72 px-2 py-3 rounded-lg">
                                <div className="flex-initial">
                                    <div
                                        className="inline-flex items-center justify-center rounded-lg bg-gradient-tl from-green-400 via-green-400 bg-green-300">
                                        <div className="p-2">
                                            <IconKey size={20} color='white' />
                                        </div>
                                    </div>
                                </div>

                                <div className="flex-1 inline-flex items-start justify-between">
                                    <div>
                                        <h2 className="text-xs font-semibold tracking-tight">Product Key</h2>
                                        <p className="text-sm text-gray-500 font-medium">{productDetails?.productKey}</p>
                                    </div>

                                    <div className="text-xs text-gray-400"> <IconCopy size={20} /> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className='mb-3 flex items-center justify-between'>
                <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Apps</p>
                {accessCheck(accessKeys.addAndUpdateApp) && <AddAppModal buttonComponent={<IconButton icon={<IconCirclePlus size={20} />} text={"Add App"} />} callback={() => getAppList()} callback2={() => getProductDetails()} />}
            </div>


            <TableComponent
                columns={columns}
                data={appList}
                totalRows={appList?.length}
                isHeader={true}
                isPagination={false}
                paginationPerPage={10}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />

            <hr className='my-3' />

            {productDetails && <PredefinedPromotionUrlsSection />}

        </Layout>
    )
}

export default DeveloperSection